// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "clientlib-components/resources/" + chunkId + "." + "3b967091" + ".js";
};